import styled from 'styled-components'

const Button = styled.button`
	cursor: pointer;
	border: 2px solid #6366f1;
	padding: 16px 32px;
	gap: 8px;
	height: 50px;
	background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
	border-radius: 22px;
	font-style: normal;
	font-weight: 600;
	font-size: 15px;
	line-height: 15px;
	color: #ffffff;
	transition: all 0.3s ease;
	box-shadow: 0px 4px 15px rgba(99, 102, 241, 0.3);
	
	&:hover {
		background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
		transform: translateY(-1px);
		box-shadow: 0px 6px 20px rgba(99, 102, 241, 0.4);
	}
`

export default Button
